var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3 elevation-2 information"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.item))]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"information-border",class:_vm.color})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24015f46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Information.vue
// module id = null
// module chunks = 